import React from 'react'
import css from './Calendar.module.css'
import Day from './components/day/Day'
import Button from 'shared/Buttons/Button/Button'
import cn from 'utils/cn'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrowRight.svg'
import { monthNames, weekDays } from 'screens/Protection/constants/dates'
import { CalendarDay } from 'screens/Protection/hooks/useCalendar'
import { IProtectionDayResponse } from 'screens/Protection/protection.types'

type Props = {
  year: number
  month: number
  weeks: CalendarDay<IProtectionDayResponse>[][]
  isToday: (date: Date) => boolean

  onPrevMonth: () => void
  onNextMonth: () => void

  handleRedirect: (id: string) => void

  onDayClick?: (e: React.MouseEvent, date: Date) => void
}

export default function Calendar({
  year,
  month,
  weeks,
  isToday,
  onPrevMonth,
  onNextMonth,
  handleRedirect,
  onDayClick,
}: Props) {
  return (
    <div className={css.schedule}>
      <div className={css.header}>
        <div className={css.controls}>
          <Button theme='grey-outline' className={cn(css.navBtn, css.navBtn__arrowLeft)} onClick={onPrevMonth}>
            <ArrowIcon />
          </Button>

          <Button theme='grey-outline' className={css.navBtn} onClick={onNextMonth}>
            <ArrowIcon />
          </Button>
        </div>

        <div className={css.left}>
          <h2 className={css.title}>
            {monthNames[month]} {year}
          </h2>
        </div>
      </div>

      <table className={css.calendar}>
        <thead>
          <tr>
            {weekDays.map((day) => (
              <th key={day} className={css.weekday}>
                {day}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {weeks.map((week, weekIndex) => (
            <tr key={weekIndex}>
              {week.map((day) => (
                <Day
                  key={day.date.toISOString()}
                  handleRedirect={handleRedirect}
                  dayNumber={day.day}
                  isCurrentMonth={day.isCurrentMonth}
                  protections={day.items}
                  isToday={isToday(day.date)}
                  onClick={onDayClick ? (e) => onDayClick(e, day.date) : undefined}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
